import { useCallback } from "react";

import { useModals } from "hooks";
import { IApiServiceError, useDealActions } from "store";
import { CurrencyType } from "store/types";

import { getDefaultMeasureData, IGroupsFormContext, MeasureData } from "../GroupsFormContext";

interface AcceptParams {
  getMaxMeasureDataKey: () => number;
  setMeasureData: React.Dispatch<React.SetStateAction<MeasureData[]>>;

  measureData: MeasureData[];
}

type UseCalculateMeasureData = (params: AcceptParams) => IGroupsFormContext["calculateMeasureData"];

export const useCalculateMeasureData: UseCalculateMeasureData = ({
  measureData,
  getMaxMeasureDataKey,
  setMeasureData
}) => {
  const { getMeasureDataCalcAction } = useDealActions();
  const { errorModal } = useModals();

  return useCallback<IGroupsFormContext["calculateMeasureData"]>(
    async (data) => {
      try {
        const { round_id, investors } = await getMeasureDataCalcAction(data);

        // let roundName = "";
        let currency: CurrencyType | null = null;
        let batch_id: number | undefined;
        let date: string | null = null;
        let accountingDate: string | null = null;

        const updatedMeasureData = measureData.map((measureData) => {
          if (!measureData.investor_id) return measureData;
          if (measureData.group_id !== data.group_id) return measureData;
          if (round_id !== measureData.round_id) return measureData;

          // if (!roundName && measureData.round_name) {
          //   roundName = measureData.round_name;
          // }

          if (!currency && measureData.currency) {
            currency = measureData.currency;
          }

          if (!batch_id && measureData.batch_id) {
            batch_id = measureData.batch_id;
          }

          if (!date && measureData.date) {
            date = measureData.date;
          }

          if (!accountingDate && measureData.accounting_date) {
            accountingDate = measureData.accounting_date;
          }

          const index = investors.findIndex((inv) => inv.id === measureData.investor_id);
          if (index >= 0) {
            const value = investors.splice(index, 1)[0].value;
            measureData.value = value;
          } else {
            measureData.value = "";
          }

          return measureData;
        });

        // Create measure data for investors without measure data
        const maxKey = getMaxMeasureDataKey();
        let investorsCount = maxKey + 1;
        const newMeasureData = investors.map((investor) => {
          const measureData = getDefaultMeasureData({
            key: investorsCount,
            investor_group: investor.investor_group,
            group_id: data.group_id,
            investor_id: investor.id,
            investor_name: investor.name,
            value: investor.value,
            round_id: data.round_id,
            // round_name: roundName,
            enable_split: false,
            accounting_date: accountingDate,
            currency,
            date,
            ...(batch_id && { batch_id })
          });
          investorsCount++;
          return measureData;
        });

        setMeasureData([...updatedMeasureData, ...newMeasureData]);
      } catch (error) {
        errorModal({ msg: (error as IApiServiceError).message });
      }
    },
    [measureData, setMeasureData, getMaxMeasureDataKey]
  );
};
